import { ActionsContent } from './utils/ActionsContent';

import PropTypes from 'prop-types';

export const BulkDelete = ({
  title, children, description = '',
  confirmAction, ...rest
}) => {
  return (
    <ActionsContent
      title={title}
      description={description}
      confirmAction={confirmAction}
      {...rest}
    >
      {children}
    </ActionsContent>
  );
};

BulkDelete.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  confirmAction: PropTypes.func,
};